import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  class: "modal-content neon"
}
const _hoisted_2 = { class: "wrapper-filter" }
const _hoisted_3 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal_header = _resolveComponent("app-modal-header")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_modal_header, { onClose: _ctx.close }, null, 8, ["onClose"]),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_AppCheckbox, {
        modelValue: _ctx.fullFillRef,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fullFillRef) = $event)),
        label: "fullFill"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_AppCheckbox, {
        modelValue: _ctx.onlySoftRef,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.onlySoftRef) = $event)),
        label: "showOnlySoft"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_AppCheckbox, {
        modelValue: _ctx.onlyBrightRef,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.onlyBrightRef) = $event)),
        label: "showOnlyBright"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_AppCheckbox, {
        modelValue: _ctx.onlyColdRef,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.onlyColdRef) = $event)),
        label: "showOnlyCold"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_AppCheckbox, {
        modelValue: _ctx.onlyWarmRef,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.onlyWarmRef) = $event)),
        label: "showOnlyWarm"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_AppCheckbox, {
        modelValue: _ctx.onlyLightRef,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.onlyLightRef) = $event)),
        label: "showOnlyLight"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_AppCheckbox, {
        modelValue: _ctx.onlyDarkRef,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.onlyDarkRef) = $event)),
        label: "showOnlyDark"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("footer", _hoisted_3, [
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.applyFilter && _ctx.applyFilter(...args)))
      }, [
        _createVNode(_component_app_button, {
          severity: "warning",
          title: "apply"
        })
      ])
    ])
  ], 512))
}